import { Component, OnInit, Input } from '@angular/core';
import { CleanerService } from "../../../injections/cleaner.service";
import { ActivatedRoute } from "@angular/router";

@Component({
    moduleId: module.id,
    selector: 'main-cleaner',
    templateUrl: '../templates/main-cleaner.html',
    providers: [],
})

export class MainCleanerComponent implements OnInit {

   public availability: Array<object>;
   public districts: Array<object>;
   public showModal: boolean = false;
   public typeModal: string;
   public editDataCleaner: boolean = false;
   public blocked: number = 0;
   public cleanerData = {
       info: null,
       availability: null,
       comments: []
   }; 
   public idCleaner: string;
    constructor(private cleanerService: CleanerService, private _route: ActivatedRoute) {

        this._route.params
        .subscribe(params => {
            this.idCleaner = params["id"];
        });
    }

    public changeCleanerBlockStatus(checkboxVal){
        
        (this.blocked == 1) ? this.unBlockCleaner() : this.blockCleaner(); 
    }

    public blockCleaner() {
        this.cleanerService.blockCleaner(this.idCleaner)
        .subscribe((status) => {
            if(status == "OK") this.blocked = 1;
        });
    }

    public unBlockCleaner() {
        this.cleanerService.unBlockCleaner(this.idCleaner)
        .subscribe((status) => {
            if(status == "OK") this.blocked = 0;
        });
    }

    public updateCleanerData(data: any) {
        this.cleanerService.updateCleanerData(this.idCleaner, data).subscribe(status => {
            console.log(status)
            if(status == "OK") {
                this.editDataCleaner = false;
                this.getCleanerById();
            }
        });
    }

    public displayModal(event){
        this.showModal = true;
        this.typeModal = event;     
    }

    public hideModal($event) {
        this.showModal = false;
    }

    private getCleanerById() {
        this.cleanerService.getCleanerById(this.idCleaner).subscribe( result => {
            this.cleanerData["info"] = result;
            this.blocked = result["blocked"];
        });
    }

    ngOnInit() { 
        this.getCleanerById();

        this.cleanerService.getCleanerAvailability(this.idCleaner).subscribe( result => {
            this.cleanerData["availability"] = result;
        });

        this.cleanerService.getCleanerComments(this.idCleaner).subscribe( result => {
            this.cleanerData["comments"] = result;
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/cleaners/components/main-cleaner.component.ts